import React__default from 'react';
import { DimensionsProvider as DimensionsProvider$1 } from '@invitae/nucleobase-core';

var DimensionsProvider = function (_a) {
    var _b = _a.withDimensions, withDimensions = _b === void 0 ? true : _b, children = _a.children;
    if (!withDimensions)
        return React__default.createElement(React__default.Fragment, null, children);
    return React__default.createElement(DimensionsProvider$1, null, children);
};

export { DimensionsProvider as default };
//# sourceMappingURL=DimensionsProvider.esm.js.map
